import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';

import { CoolingOffImage } from '@src/assets';

import styles from './FullDealCoolingOffAlert.module.scss';

export default function FullDealCoolingOffAlert() {
  return (
    <Space direction="row" align="center" size={16} className={styles.wrapper}>
      <div className={styles.iconContainer}>
        <img src={CoolingOffImage} height={36} width={36} alt="Иконка периода охлаждения" />
      </div>
      <Space direction="column" size={4}>
        <Text size={14}>По закону при займе от 50 000 ₽ сможем перевести деньги через 4 часа</Text>
      </Space>
    </Space>
  );
}
